import { CART_TRACKER_TYPE_FOR_V1_AND_V2 } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

export const onTrackCartMyCouponApply = async () => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_TRACKER_TYPE_FOR_V1_AND_V2.CART_MY_COUPON_APPLY,
    data: {
      scope: 'shop',
      event_category: 'Cart',
    },
  });
};
